export const routes = (parentName) => {
  return [
    {
      path: "consumer",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Consumer-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Consumer-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Consumer-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Consumer-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
